import { Component, OnInit, Output, EventEmitter, Inject, Input } from '@angular/core';
import { DOWNLOAD_TYPE } from '@enums/download-type.enum';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { ReportButtonsEnum } from '@core/enums/report-buttons.enum';

@Component({
  selector: 'app-report-buttons',
  templateUrl: './report-buttons.component.html',
  styleUrls: ['./report-buttons.component.scss'],
  animations: [
    trigger('showMenu', [
      state(
        'expanded',
        style({ height: '100vh', minHeight: '100vh' })
      ),
      state(
        'collapsed',
        style({ height: '0', minHeight: '0' })
      ),
      transition(
        'expanded => collapsed',
        [animate('0.2s')]
      ),
      transition(
        'collapsed => expanded',
        [animate('0.2s')]
      )
    ])
  ]
})
export class ReportButtonsComponent implements OnInit {

  @Input() label: string = 'RELATÓRIOS'
  typeReport = ReportButtonsEnum;
  DOWNLOAD_TYPE = DOWNLOAD_TYPE;

  @Output() reportButtonEmmiter: EventEmitter<string> = new EventEmitter();

  constructor( ) { }

  ngOnInit( ): void { }

  selectReport(type): void {
    this.reportButtonEmmiter.emit(type);
  }
}
